export class Transcript{

  public label: string;
  public url: string;
  
  constructor(object:any = null) {

    this.set(object);
  };
  
  set(object:any){
    if(object){
      if(object["label"] != null){
        this.label = object["label"];
      }
      if(object["url"] != null){
        this.url = object["url"];
      }

    }
  }

}
